"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _reduxActions = require("redux-actions");
var R = _interopRequireWildcard(require("ramda"));
var _helpers = require("./helpers");
var _actions = require("./actions");
var _constants = require("./constants");
var _handleActions;
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var initialState = {
  basketsOrderIDs: [],
  baskets: {},
  basketsSimplified: [],
  basketsSimplifiedPagination: {
    total: 0,
    perPage: 0
  },
  pagination: {
    total: 0,
    perPage: 0,
    initialPage: 1
  },
  managers: [],
  offersReviewsLinks: [],
  activeBasketsStatus: _constants.BASKET_STATUSES_MAP.ALL,
  tempEditBasketsData: {},
  templates: []
};
var _default = exports.default = (0, _reduxActions.handleActions)((_handleActions = {}, _defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_handleActions, _actions.setBaskets, function (state, _ref) {
  var baskets = _ref.payload;
  return R.assoc('baskets', baskets, state);
}), _actions.setBasketsSimplified, function (state, _ref2) {
  var baskets = _ref2.payload;
  return R.assoc('basketsSimplified', baskets, state);
}), _actions.mergeBasketsSimplified, function (state, _ref3) {
  var baskets = _ref3.payload;
  return R.over(R.lensProp('basketsSimplified'), function (prevBaskets) {
    return (0, _helpers.mergeBaskets)(prevBaskets, baskets);
  }, state);
}), _actions.setPagination, function (state, _ref4) {
  var pagination = _ref4.payload;
  return R.assoc('pagination', pagination, state);
}), _actions.setBasketsOrderIDs, function (state, _ref5) {
  var ids = _ref5.payload;
  return R.assoc('basketsOrderIDs', ids, state);
}), _actions.resetBaskets, function () {
  return R.clone(initialState);
}), _actions.addBasket, function (state, _ref6) {
  var basket = _ref6.payload;
  return R.call(R.pipe(R.over(R.lensProp('basketsOrderIDs'), R.prepend(R.prop('id', basket))), R.set(R.lensPath(['baskets', R.prop('id', basket)]), basket)), state);
}), _actions.removeBasket, function (state, _ref7) {
  var basketID = _ref7.payload;
  return R.call(R.pipe(R.over(R.lensProp('basketsOrderIDs'), R.without([basketID])), R.over(R.lensProp('baskets'), R.dissoc(basketID))), state);
}), _actions.setBasket, function (state, _ref8) {
  var basket = _ref8.payload;
  return R.assocPath(['baskets', basket.id], basket, state);
}), _actions.removeOfferFromBasket, function (state, _ref9) {
  var _ref9$payload = _ref9.payload,
    basketID = _ref9$payload.basketID,
    offerID = _ref9$payload.offerID;
  return R.call(R.pipe(R.over(R.lensPath(['baskets', basketID, 'offersIDs']), R.without([offerID])), R.dissocPath(['baskets', basketID, 'offersExtra', offerID])), state);
}), _defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_handleActions, _actions.removeOfferFromSimplifyBasket, function (state, _ref10) {
  var _ref10$payload = _ref10.payload,
    basketID = _ref10$payload.basketID,
    offerID = _ref10$payload.offerID;
  return R.over(R.lensPath(['basketsSimplified', (0, _helpers.findSimplifyBasketIndex)(state, basketID), 'offers']), R.filter(function (_ref11) {
    var id = _ref11.id;
    return id !== offerID;
  }), state);
}), _actions.addOfferToSimplifyBasket, function (state, _ref12) {
  var _ref12$payload = _ref12.payload,
    basketID = _ref12$payload.basketID,
    offer = _ref12$payload.offer;
  return R.over(R.lensPath(['basketsSimplified', (0, _helpers.findSimplifyBasketIndex)(state, basketID), 'offers']), R.append(offer), state);
}), _actions.updateSimplifyBasket, function (state, _ref13) {
  var _ref13$payload = _ref13.payload,
    basketID = _ref13$payload.basketID,
    basket = _ref13$payload.basket;
  return R.over(R.lensPath(['basketsSimplified', (0, _helpers.findSimplifyBasketIndex)(state, basketID)]), function (prevBasket) {
    return R.mergeAll([prevBasket, basket]);
  }, state);
}), _actions.removeSimplifyBasket, function (state, _ref14) {
  var basketID = _ref14.payload;
  return R.over(R.lensProp('basketsSimplified'), R.filter(function (_ref15) {
    var id = _ref15.id;
    return id !== basketID;
  }), state);
}), _actions.addSimplifyBasket, function (state, _ref16) {
  var basket = _ref16.payload;
  return R.over(R.lensProp('basketsSimplified'), R.prepend(basket), state);
}), _actions.updateOffersPositionInBasket, function (state, _ref17) {
  var _ref17$payload = _ref17.payload,
    basketID = _ref17$payload.basketID,
    newPosition = _ref17$payload.newPosition,
    currentPosition = _ref17$payload.currentPosition;
  return R.over(R.lensPath(['baskets', basketID, 'offersIDs']), R.move(currentPosition, newPosition), state);
}), _actions.setManagers, function (state, _ref18) {
  var managers = _ref18.payload;
  return R.assoc('managers', managers, state);
}), _actions.setBasketsSimplifiedPagination, function (state, _ref19) {
  var pagination = _ref19.payload;
  return R.assoc('basketsSimplifiedPagination', pagination, state);
}), _actions.setActiveBasketsStatus, function (state, _ref20) {
  var status = _ref20.payload;
  return R.assoc('activeBasketsStatus', status, state);
}), _actions.mergeTempEditBasketData, function (state, _ref21) {
  var _ref21$payload = _ref21.payload,
    basketID = _ref21$payload.basketID,
    data = _ref21$payload.data;
  return R.over(R.lensPath(['tempEditBasketsData', basketID]), function () {
    var tempEditBasketData = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    return R.mergeAll([tempEditBasketData, data]);
  }, state);
}), _defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_handleActions, _actions.removeTempEditBasketData, function (state, _ref22) {
  var basketID = _ref22.payload;
  return R.dissocPath(['tempEditBasketsData', basketID], state);
}), _actions.removeClaimFromBasket, function (state, _ref23) {
  var basketID = _ref23.payload;
  return R.assocPath(['baskets', basketID, 'claim'], null, state);
}), _actions.setClaimToBasket, function (state, _ref24) {
  var _ref24$payload = _ref24.payload,
    basketID = _ref24$payload.basketID,
    claim = _ref24$payload.claim;
  return R.assocPath(['baskets', basketID, 'claim'], claim, state);
}), _actions.setOffersReviewsLinks, function (state, _ref25) {
  var links = _ref25.payload;
  return R.assoc('offersReviewsLinks', links, state);
}), _actions.setBasketTemplates, function (state, _ref26) {
  var templates = _ref26.payload;
  return R.assoc('templates', templates, state);
})), initialState);